// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6134400f","455":"283c6a27","977":"4a3a6915"}[chunkId] + ".chunk.js";
};